import { useIntl } from "react-intl";

import { Entry } from "./Entry";

import { WithEmptyList } from "~/client/components/search/SearchBoxDropdown/WithEmptyList";
import { buildSearchPathWithParams } from "~/client/components/search/SearchHistory/buildSearchPathWithParams";
import type { SearchHistoryEntryWithPersistency } from "~/client/components/search/SearchHistory/EntryListContainer";
import type { CreateSearchFilterSetInput } from "~/client/generated/schema";
import type { ListItemSelection } from "~/client/hooks/useSelectListItemByKey";

const findSelectedEntry = (listIndex, entries, { isItemSelected }) =>
  entries.find((_, itemIndex) => isItemSelected({ listIndex, itemIndex }));

interface Props {
  listIndex: number;
  entries: ReadonlyArray<SearchHistoryEntryWithPersistency>;
  listItemSelection: ListItemSelection;
  onSaveFilterSet: (filterSet: CreateSearchFilterSetInput) => void;
  onDelete: (id: string) => void;
}
export const EntryList: React.FC<Props> = ({ listIndex, entries, listItemSelection, onSaveFilterSet, onDelete }) => {
  const intl = useIntl();

  const selected = findSelectedEntry(listIndex, entries, listItemSelection);
  if (listItemSelection.isSubmitting && selected) {
    location.assign(buildSearchPathWithParams(selected.keywords, selected));
  }

  return (
    <WithEmptyList
      itemCount={entries.length}
      message={intl.formatMessage({ id: "searchBox.searchHistoryDoesNotExist" })}
    >
      <ul>
        {entries.map((e) => (
          <Entry
            key={e.id}
            entry={e}
            isSelected={e.id === selected?.id}
            onSaveFilterSet={onSaveFilterSet}
            onDelete={onDelete}
          />
        ))}
      </ul>
    </WithEmptyList>
  );
};
